<div class="form-step-header-wrapper">
    <span class="step sir-text-style-paragraph-l-bold" data-cy="step">
        <sirius-text-html
            textStyleSize="l"
            [html]="
                (translations()?.stepHeader?.stepCounter ?? '')
                    | interpolate: { step: step(), stepCount: 5 }
            ">
        </sirius-text-html>
    </span>
    <h1 class="title sir-text-style-title-xl-default" data-cy="title">{{ title() }}</h1>

    @if (step() > STEP_THRESHOLD_INDUSTRY) {
        <div class="industry-application-container">
            <sirius-text-html
                textStyleSize="m"
                [html]="
                    (translations()?.stepHeader?.industry ?? '')
                        | interpolate: { industry: industry() }
                ">
            </sirius-text-html>
            @if (step() > STEP_THRESHOLD_APPLICATION) {
                <sirius-text-html
                    textStyleSize="m"
                    [html]="
                        (translations()?.stepHeader?.application ?? '')
                            | interpolate: { application: application() }
                    ">
                </sirius-text-html>
            }
        </div>
    }

    @if (!lastStep()) {
        <p class="description sir-text-style-paragraph-l-default" data-cy="description">{{ description() }}</p>
    } @else {
        <div class="description-container sir-text-style-paragraph-l-default">
            <div class="dynamic-description description-last-step" data-cy="description-input">
                <sirius-text-html
                    textStyleSize="l"
                    [html]="
                        (translations()?.stepHeader?.description ?? '')
                            | interpolate: { industry: industry(), application: application() }
                    ">
                </sirius-text-html>
                <br />
                <sirius-text-html
                    textStyleSize="l"
                    [html]="translations()?.stepHeader?.descriptionContact ?? ''">
                </sirius-text-html>
            </div>
        </div>

        <div class="button">
            <button
                data-cy="anchor-button"
                siriusButton
                size="large"
                [buttonText]="translations()!.button.completeGuide"
                buttonType="primary"
                iconName="arrow_down"
                (click)="anchorClickEvent()"></button>
        </div>
    }
</div>
